/** Client-only copy helper with a fallback for browsers or frames that block the async clipboard API. */
export const copyText = async (text: string): Promise<boolean> => {
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text)

            return true
        }
    }
    catch {
        // Fall through to the legacy path below.
    }

    try {
        const textarea = document.createElement('textarea')

        textarea.value = text
        textarea.setAttribute('readonly', '')
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()

        const copied = document.execCommand('copy')

        document.body.removeChild(textarea)

        return copied
    }
    catch {
        return false
    }
}
